import React from 'react';
import Logo from '../../Logo';
import ContactDetails from '../../ContactDetails';

export const Stepper = ({ activeStep, isInternal }) => {
  const steps = [
    {
      name: 'Choose Services',
      slug: 'orderType'
    },
    {
      name: 'Order Details',
      slug: 'orderDetails'
    }
  ];

  if (!isInternal) {
    steps.push({
      name: 'Contact Information',
      slug: 'contactInformation'
    });
  }

  return (
    <div className="stepper-container">
      <div className="inner-container">
        <div className="text-center">
          <Logo isYellow height={45} />
        </div>
        <div className="d-flex-col stepper-items">
          {steps.map((item, index) => {
            const isActive = activeStep >= index;
            const isCurrentStep = activeStep === index;
            return (
              <div key={item.slug} className={`step-item mb-0 ${isActive ? 'active' : ''}`}>
                <div className={`step-item-number-container ${isCurrentStep ? 'current-step' : ''}`}>
                  <p>{index + 1}</p>
                </div>
                <div className="step-item-details-container">
                  <p className="step-number mb-1">STEP {index + 1}</p>
                  <p className="step-name">{item.name}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <ContactDetails />
    </div>
  );
};
